import type {
  SleepEntity,
  SleepPropsPub,
  SleepPropsPvt,
} from './entity/sleepEntity';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { SleepJsonPub, SleepJsonPvt } from '@/types/domain/sleep/entities/sleepEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 睡眠ドメインサービス(施設)
 */
export class SleepNurseryDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * sendNurserySleep
   * @param entity entity
   */
  async sendNurserySleep(
    entity: SleepEntity,
  ) {
    await this.wagakoNurseryApi.send<
      SleepPropsPvt,
      SleepJsonPvt,
      SleepPropsPub,
      SleepJsonPub
    >(entity);
  }

  /**
   * removeNurserySleep
   * @param entity entity
   */
  async removeNurserySleep(
    entity: SleepEntity,
  ) {
    await this.wagakoNurseryApi.remove<
      SleepPropsPvt,
      SleepJsonPvt,
      SleepPropsPub,
      SleepJsonPub
    >(entity);
  }
}
